import { useSearchParams } from 'react-router-dom';

export const INVITE_CODE = 'code';
export const useInviteCode = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get(INVITE_CODE) ?? undefined;
};
